import { toDbId } from "~/utils/graphql-helpers";

/**
 * ExternalObjectInput.objectId is a main DB id string.
 * Decimal ids pass through; typeahead selections are relay IDs.
 */
export const toExternalObjectId = (id: string): string => {
  if (/^\d+$/.test(id)) return id;
  try {
    const dbId = toDbId(id);
    return Number.isFinite(dbId) ? dbId.toString() : id;
  } catch {
    return id;
  }
};
